import { useEffect, useState, useCallback } from 'react'

/* Actieve MIDI-bezetter — schrijven in localStorage + custom event zodat
   de header-badge in Layout live meebeweegt. Doel: één LPD8-mk2 wordt gedeeld
   tussen Kempenvision-regie, ImageCompo-regie en (later) schermregie; admin
   moet altijd kunnen zien wie de knoppen nu bezit. */

const KEY = 'midi_current_context'
const EVT = 'midi:context'

const LABELS = {
  kempenvision: 'Kempenvision',
  imagecompo:   'Image Compo',
  tournaments:  'Toernooien',
  screens:      'Schermregie',
}

export function labelForScope(scope) { return LABELS[scope] || scope }

/* Zet de actieve bezetter tijdens mount, ruim op bij unmount. Gebruikers
   van deze hook: alle MIDI-pagina's (KempenvisionMidiPage, ImageCompoMidiPage,
   TournamentMidiPage) — één regel. */
export function useMidiContextIndicator(scope) {
  useEffect(() => {
    if (!scope) return
    try {
      localStorage.setItem(KEY, scope)
      window.dispatchEvent(new CustomEvent(EVT, { detail: { scope } }))
    } catch {}
    return () => {
      try {
        const cur = localStorage.getItem(KEY)
        if (cur === scope) {
          localStorage.removeItem(KEY)
          window.dispatchEvent(new CustomEvent(EVT, { detail: { scope: null } }))
        }
      } catch {}
    }
  }, [scope])
}

/* Reader-hook voor de badge. Reageert op storage-events (andere tab) én
   op onze eigen midi:context event (deze tab). */
export function useMidiContextReader() {
  const [scope, setScope] = useState(() => {
    try { return localStorage.getItem(KEY) } catch { return null }
  })
  const refresh = useCallback(() => {
    try { setScope(localStorage.getItem(KEY)) } catch { setScope(null) }
  }, [])
  useEffect(() => {
    const onStorage = (e) => { if (e.key === KEY) refresh() }
    const onCustom  = (e) => setScope(e.detail?.scope ?? null)
    window.addEventListener('storage', onStorage)
    window.addEventListener(EVT, onCustom)
    return () => {
      window.removeEventListener('storage', onStorage)
      window.removeEventListener(EVT, onCustom)
    }
  }, [refresh])
  return scope
}
